import {
    InputAdornment,
    IconButton,
    TextFieldProps,
    TextField,
} from '@mui/material'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
function SearchTextField(prop: TextFieldProps) {
    return (
        <TextField
            {...prop}
            size="medium"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            disabled
                            edge="end"
                        >
                            <QrCodeScannerIcon
                                color="primary"
                                style={{ fontSize: 'inherit' }}
                            />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )
}

export default SearchTextField
